"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next13_utils_request_1 = __importDefault(require("@gerenciatd/next13.utils.request"));
const next13_utils_monitoring_sonda_1 = __importDefault(require("@gerenciatd/next13.utils.monitoring.sonda"));
const next13_utils_monitoring_get_uuid_1 = __importDefault(require("@gerenciatd/next13.utils.monitoring.get-uuid"));
const processName = "ADABYRON-API";
const getAllSearchInfo = ({ segment, context }) => {
    const idRequest = (0, next13_utils_monitoring_get_uuid_1.default)();
    const sonda = new next13_utils_monitoring_sonda_1.default({
        eventName: "MISCELLANEOUS.GET_ALL_SEARCH_INFO",
        context,
        uniqueId: idRequest,
        origin: processName,
    });
    let URL_API = `?${idRequest}`;
    const { custo: connectionData } = context.environment;
    const { endpoint: host } = connectionData;
    URL_API = `${host}/v2/static/search/searched_list_particulares.json${URL_API}`;
    if (segment === 'empresas') {
        URL_API = `${host}/v2/static/search/searched_list_empresas.json${URL_API}`;
    }
    try {
        const request = new next13_utils_request_1.default({
            method: "GET",
            endpoint: URL_API,
            sonda: sonda,
            headers: {
                "content-type": "text/plain;charset=UTF-8",
            },
        });
        return request.makeRequest();
    }
    catch (err) {
        return null;
    }
};
exports.default = getAllSearchInfo;
//# sourceMappingURL=index.js.map